import { Mail, MessageCircle, Send } from "@tamagui/lucide-icons";
import { useToastController } from "@tamagui/toast";
import { observer } from "mobx-react-lite";
import type React from "react";
import { useCallback, useMemo } from "react";
import type { ModalProps } from "react-native";
import { useApi } from "../../core/apis";
import {
  FormDataModal,
  FormSheetType,
  type FormValues,
} from "../../core/components/FormDataModal";
import { trackEvent } from "../../core/trackEvent";

export const FeedbackModal: React.FC<
  ModalProps & { title: string; userUid: string; onClose: () => void }
> = observer(({ userUid, title, ...props }) => {
  const toast = useToastController();

  const { feedbackApi } = useApi();

  const addFeedback = useCallback(
    async (data: FormValues) => {
      const fromEmail = `${data.fromEmail}`;
      const fromUserId = userUid ?? "";
      const message = `${data.message}`;

      void feedbackApi.add({ fromEmail, fromUserId, message });

      trackEvent("feedback_created");

      toast.show("Request sent!");
      props.onClose();
    },
    [userUid, feedbackApi, props.onClose, toast],
  );

  return (
    <FormDataModal
      title={title}
      icon={MessageCircle}
      description="We love to here from you. Feature requests, bugs, thoughts or anything you can think of. Talk to you soon!"
      buttonSaveText="Send"
      buttonIcon={Send}
      values={useMemo(() => ({}), [])}
      form={[
        {
          formKey: "fromEmail",
          label: "Email",
          type: FormSheetType.Email,
          icon: Mail,
          required: true,
          placeholder: "Your email...",
        },
        {
          formKey: "message",
          label: "Message",
          required: true,
          type: FormSheetType.Textarea,
          icon: MessageCircle,
          placeholder: "Your message...",
        },
      ]}
      onSave={addFeedback}
      {...props}
    />
  );
});
